import { onMounted, onUnmounted, type Ref } from 'vue';

const WIDE_SCREEN_QUERY = '(min-width: 1024px)';

/**
 * Drives `isWideScreen` from matchMedia; caller handles layout side-effects in `onWideChanged`.
 */
export function useNavBreakpoints(
  isWideScreen: Ref<boolean>,
  onWideChanged: (wide: boolean) => void
): void {
  let mediaQuery: MediaQueryList | null = null;

  function updateWideScreen(): void {
    isWideScreen.value = mediaQuery?.matches ?? true;
    onWideChanged(isWideScreen.value);
  }

  onMounted(() => {
    mediaQuery = window.matchMedia(WIDE_SCREEN_QUERY);
    updateWideScreen();
    mediaQuery.addEventListener('change', updateWideScreen);
  });

  onUnmounted(() => {
    mediaQuery?.removeEventListener('change', updateWideScreen);
  });
}
